module.exports = __webpack_public_path__ + "img/videoTest1.e6b5e79b.png";